import React from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';

interface DialogCancelEventProps {
  eventId: number; // event id to cancel
  onSuccess: () => void;  // Callback to refresh events list after cancellation
  onCancel: () => void; // Callback to close the dialog
}

export const DialogCancelEvent: React.FC<DialogCancelEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleCancelEvent, updating } = useEvent();

  const handleCancel = async () => {
    const success = await handleCancelEvent(eventId);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  return (
    <CustomDialog
      title="Are you sure you want to cancel this event?"
      description="By requesting a cancelation your event will be released from the ETA TA Event Calendar."
      primaryButtonText="Yes, cancel this event"
      secondaryButtonText="Exit"
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleCancel}
      onSecondaryButtonClick={onCancel}
      disablePrimaryButton={updating}
    />
  );
}; 